import {Tab, Tabs} from "react-bootstrap";
import React, {useState} from "react";
import SetupIndividualGamePage from "./SetupIndividualGamePage";
import SetupGroupGamesPage from "./SetupGroupGamesPage";
import cabinetStyle from "./MentorCabinet.module.css";
import Banner from "./Banner";
import {useTranslation} from "react-i18next";

function SetupPage(props) {
    const [key, setKey] = useState('individualGames');
    const { t } = useTranslation('translation', { keyPrefix: 'gamesSetupPage' });

    return (
        <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-4"
                    fill
                    style={{
                        width: "660px",
                        fontWeight: "bold"
                    }}
                >
                    <Tab eventKey="individualGames" title={t('titleIndividualGame')}>
                        <SetupIndividualGamePage callBack={props.callBack}
                                                 freeTier={props.freeTier}
                                                 currentBalance={props.currentBalance}
                                                 setSelectedGameType={props.setSelectedGameType}/>
                    </Tab>
                    <Tab eventKey="groupGames" title={t('titleGroupGame')}>
                        <SetupGroupGamesPage callBack={props.callBack}
                                             mentorEmail={props.mentorEmail}
                                             freeTier={props.freeTier}
                                             currentBalance={props.currentBalance}
                                             setSelectedGameType={props.setSelectedGameType}/>
                    </Tab>
                </Tabs>
            </div>
        </>

    )
}

export default SetupPage